import {
  CreateSource,
  EngagementId,
  TprmScopeId,
  TprmScopeMin,
  TprmScopeVisibility,
  SourceMin,
} from "platformed-client/types";
import {invalidateQueries, q} from "../../state";
import {platformedClient} from "..";

export async function get(scopeId: TprmScopeId): Promise<TprmScopeMin> {
  return platformedClient.internalRequest("get", "/region/{region}/api/tprm/scopes/{scope_id}", {
    path: {scope_id: scopeId},
  });
}

export async function createSource(
  engagementId: EngagementId,
  scopeId: TprmScopeId,
  source: CreateSource[],
  options?: {skipInvalidation?: boolean},
): Promise<SourceMin[]> {
  const res = await platformedClient.internalRequest("post", "/region/{region}/api/tprm/scopes/{scope_id}/sources", {
    path: {scope_id: scopeId},
    query: options?.skipInvalidation ? {skip_invalidation: true} : {},
    body: source,
  });
  await invalidateQueries([q.tprm.scopeSources.filter(scopeId), q.tprm.engagement.filter(engagementId)]);
  return res;
}

export async function delete_(scopeId: TprmScopeId): Promise<string> {
  const res = await platformedClient.internalRequest("delete", "/region/{region}/api/tprm/scopes/{scope_id}", {
    path: {scope_id: scopeId},
  });
  await invalidateQueries([
    q.tprm.source.filter(),
    q.tprm.scope.filter(),
    q.tprm.scopeSources.filter(scopeId),
    q.tprm.engagementScopes.filter(),
    q.tprm.engagementSources.filter(),
    q.tprm.engagementComplexityAssessments.filter(),
    q.tprm.engagementScopeBadges.filter(),
  ]);
  return res;
}

export async function merge(
  scopeId: TprmScopeId,
  targetScopeId: TprmScopeId,
  sourceNameSuffix?: string,
): Promise<string> {
  const res = await platformedClient.internalRequest("post", "/region/{region}/api/tprm/scopes/{scope_id}/merge", {
    path: {scope_id: scopeId},
    body: {target_scope_id: targetScopeId, source_name_suffix: sourceNameSuffix ?? null},
  });
  await invalidateQueries([
    q.tprm.source.filter(),
    q.tprm.scope.filter(),
    q.tprm.scopeSources.filter(),
    q.tprm.engagementScopes.filter(),
    q.tprm.engagementSources.filter(),
    q.tprm.engagementComplexityAssessments.filter(),
    q.tprm.engagementScopeBadges.filter(),
  ]);
  return res;
}

export async function listSources(scopeId: TprmScopeId, filtered: TprmScopeVisibility): Promise<SourceMin[]> {
  return platformedClient.internalRequest(
    "get",
    "/region/{region}/api/tprm/scopes/{scope_id}/sources/{risk_or_control}",
    {path: {scope_id: scopeId, risk_or_control: filtered}},
  );
}
